import Vue from "vue";
import { RouteConfig } from "vue-router";

import { PermissionName } from "../../common/mixins/permission";
import UserViewPage from "./pages/UserViewPage.vue";
import UserCreatePage from "./pages/UserCreatePage.vue";
import UserUpdatePage from "./pages/UserUpdatePage.vue";
import UserSetPasswordPage from "./pages/UserSetPasswordPage.vue";

export const UserRouter: (prefix?: string) => RouteConfig[] = (
  prefix = "user"
) => [
  {
    name: "UserViewPage",
    path: prefix,
    component: UserViewPage,
    meta: { title: "User List" },
    beforeEnter: (to, from, next) => {
      if (
        Vue.prototype.$dep.authUseCase.hasPermission(PermissionName.USER_VIEW)
      ) {
        document.title = to.meta.title;
        next();
        return;
      }
      next({ path: "/" });
    }
  },
  {
    name: "UserCreatePage",
    path: `${prefix}/create`,
    component: UserCreatePage,
    meta: { title: "Create New User" },
    beforeEnter: (to, from, next) => {
      if (
        Vue.prototype.$dep.authUseCase.hasPermission(PermissionName.USER_CREATE)
      ) {
        document.title = to.meta.title;
        next();
        return;
      }
      next({ path: "/" });
    }
  },
  {
    name: "UserUpdatePage",
    path: `${prefix}/edit/:id`,
    component: UserUpdatePage,
    meta: { title: "Edit User" },
    beforeEnter: (to, from, next) => {
      if (
        Vue.prototype.$dep.authUseCase.hasPermission(PermissionName.USER_EDIT)
      ) {
        document.title = to.meta.title;
        next();
        return;
      }
      next({ path: "/" });
    }
  },
  {
    name: "UserSetPasswordPage",
    path: `${prefix}/setpassword/:id`,
    component: UserSetPasswordPage,
    meta: { title: "Set Password" },
    beforeEnter: (to, from, next) => {
      if (
        Vue.prototype.$dep.authUseCase.hasPermission(PermissionName.USER_EDIT)
      ) {
        document.title = to.meta.title;
        next();
        return;
      }
      next({ path: "/" });
    }
  }
];
